import {reactive} from '@vue/composition-api'

/**
 * Returns a reactive object with `data`, `error` and `loading` properties, that
 * can be kept up-to-date with a promise.
 */
export default function useApiRequest () {
  const async = reactive({
    data: undefined,
    loading: false,
    error: undefined,
    watch (promise) {
      async.loading = true
      promise.then(
        res => {
          async.data = res
          async.loading = false
        },
        err => {
          async.error = err
          async.loading = false
        },
      )
    },
  })
  return async
}
